import { createSlice } from '@reduxjs/toolkit';
// import { useFetchUser } from './userAPI';
// import useAuthorization from '../../hooks/useAuthorization';

const initialState = {
  issues: [],
  status: 'idle',
  pendingIssue: 0,
  email: '',
  firstname: '',
  lastname: '',
  mediatorRedirect: '',
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// export const fetchProfileAsync = createAsyncThunk(
//   'user/fetchProfileAsync',
//   async (header) => {
//     // const [getHeader] = useAuthorization();
//     const response = await useFetchUser(header);
//     // The value we return becomes the `fulfilled` action payload
//     return response.data;
//   }
// );

export const issueSlice = createSlice({
  name: 'issue',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPendingIssue: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.email = action.payload.email;
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.pendingIssue = action.payload.requestId;
    },
    setMediatorRedirect: (state, action) => {
      state.mediatorRedirect = action.payload;
    },
    unloadPendingIssue: (state) => {
      state.pendingIssue = 0;
    },
    unloadEmail: (state) => {
      state.email = '';
    },
    unloadFirstname: (state) => {
      state.firstname = '';
    },
    unloadLastname: (state) => {
      state.lastname = '';
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchProfileAsync.pending, (state) => {
//         state.status = 'loading';
//       })
//       .addCase(fetchProfileAsync.fulfilled, (state, action) => {
//         state.status = 'idle';
//         state.user = action.payload;
//       });
//   },
});

export const { setPendingIssue, unloadPendingIssue, setMediatorRedirect, unloadEmail, unloadFirstname, unloadLastname } = issueSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectPendingIssue = (state) => state.issue.pendingIssue
export const selectEmail = (state) => state.issue.email
export const selectFirstname = (state) => state.issue.firstname
export const selectLastname = (state) => state.issue.lastname
export const selectMediatorRedirect = (state) => state.issue.mediatorRedirect

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd = (amount) => (dispatch, getState) => {
//   const currentValue = selectCount(getState());
//   if (currentValue % 2 === 1) {
//     dispatch(incrementByAmount(amount));
//   }
// };

export default issueSlice.reducer;
